import Avatar from '@mui/material/Avatar';
export const userColumns = [
  { field: "id", headerName: "ID", width: 70 },
  {
    field: "username",
    headerName: "User Name",
    width: 150,
  },
  {
    field: "image",
    headerName: "Image",
    width: 100,
    renderCell: (params) => <Avatar src={params.value} alt="User" />,
  },
  {
    field: "email",
    headerName: "Email",
    width: 200,
  },
  {
    field: "password",
    headerName: "Password",
    width: 150,
  },
  {
    field: "status",
  headerName: "Status",
  width: 120,
  renderCell: (params) => {
    return (
      <div className={`cellWithStatus ${params.row.status.toLowerCase()}`}>
        {params.row.status}
      </div>
    );
  }
  },
  {
    field: "age",
    headerName: "Age",
    type: "number",
    width: 90,
  },
];

export const userRows = [
  {
    id: 1,
    username: 'gracepatel',
    image: 'https://www.shutterstock.com/image-vector/black-woman-smiling-portrait-vector-600nw-2281497689.jpg',
    email: 'grace@example.com',
    password: 'grace123',
    status: 'Active',
    age: 21,
  },
  {
    id: 2,
    username: 'rahuldev',
    image: 'https://www.shutterstock.com/image-vector/black-woman-smiling-portrait-vector-600nw-2281497689.jpg',
    email: 'rahul@example.com',
    password: 'rahul@123',
    status: 'Pending',
    age: 25,
  },
  {
    id: 3,
    username: 'jaya_singh',
    image: 'https://www.shutterstock.com/image-vector/black-woman-smiling-portrait-vector-600nw-2281497689.jpg',
    email: 'jaya@gmail.com',
    password: 'jay@pass',
    status: 'Blocked',
    age: 23,
  },
  {
    id: 4,
    username: 'amit_kumar',
    image: 'https://www.shutterstock.com/image-vector/black-woman-smiling-portrait-vector-600nw-2281497689.jpg',
    email: 'amit@yahoo.com',
    password: 'amit456',
    status: 'Active',
    age: 29,
  },
  {
    id: 5,
    username: 'riya_chaudhary',
    image: 'https://www.shutterstock.com/image-vector/black-woman-smiling-portrait-vector-600nw-2281497689.jpg',
    email: 'riya@gmail.com',
    password: 'riya789',
    status: 'Pending',
    age: 24,
  },
  {
    id: 6,
    username: 'sarthak_m',
    image: 'https://www.shutterstock.com/image-vector/black-woman-smiling-portrait-vector-600nw-2281497689.jpg',
    email: 'sarthak@gmail.com',
    password: 'sarthak007',
    status: 'Active',
    age: 30,
  },
  {
    id: 7,
    username: 'anika_verma',
    image: 'https://www.shutterstock.com/image-vector/black-woman-smiling-portrait-vector-600nw-2281497689.jpg',
    email: 'anika@example.com',
    password: 'anika@321',
    status: 'Blocked',
    age: 26,
  },
  {
    id: 8,
    username: 'neha_gupta',
    image: 'https://www.shutterstock.com/image-vector/black-woman-smiling-portrait-vector-600nw-2281497689.jpg',
    email: 'ne=8ha.g@example.com',
    password: 'neha!234',
    status: 'Active',
    age: 22,
  },
  {
    id: 9,
    username: 'manish_rawat',
    image: 'https://www.shutterstock.com/image-vector/black-woman-smiling-portrait-vector-600nw-2281497689.jpg',
    email: 'manish@example.com',
    password: 'rawat2023',
    status: 'Pending',
    age: 33,
  },
  {
    id: 10,
    username: 'kavita_shah',
    image: 'https://www.shutterstock.com/image-vector/black-woman-smiling-portrait-vector-600nw-2281497689.jpg',
    email: 'kavita@shah.com',
    password: 'kavi1234',
    status: 'Active',
    age: 27,
  },
  {
    id: 11,
    username: 'arjun_mehta',
    image: 'https://www.shutterstock.com/image-vector/black-woman-smiling-portrait-vector-600nw-2281497689.jpg',
    email: 'arjun@gmail.com',
    password: 'mehta987',
    status: 'Blocked',
    age: 31,
  },
  {
    id: 12,
    username: 'priya_rana',
    image: 'https://www.shutterstock.com/image-vector/black-woman-smiling-portrait-vector-600nw-2281497689.jpg',
    email: 'priya@example.com',
    password: 'priya_2022',
    status: 'Active',
    age: 22,
  },
  {
    id: 13,
    username: 'vivek_sharma',
    image: 'https://www.shutterstock.com/image-vector/black-woman-smiling-portrait-vector-600nw-2281497689.jpg',
    email: 'vivek.sharma@gmail.com',
    password: 'viveksharma',
    status: 'Pending',
    age: 28,
  },
  {
    id: 14,
    username: 'swati_das',
    image: 'https://www.shutterstock.com/image-vector/black-woman-smiling-portrait-vector-600nw-2281497689.jpg',
    email: 'swati@das.com',
    password: 'swatid@123',
    status: 'Blocked',
    age: 35,
  },
  {
    id: 15,
    username: 'nishant_r',
    image: 'https://www.shutterstock.com/image-vector/black-woman-smiling-portrait-vector-600nw-2281497689.jpg',
    email: 'nishant@gmail.com',
    password: 'nishant007',
    status: 'Active',
    age: 26,
  },
  {
    id: 16,
    username: 'meera_nair',
    image: 'https://www.shutterstock.com/image-vector/black-woman-smiling-portrait-vector-600nw-2281497689.jpg',
    email: 'meera@example.com',
    password: 'meera@456',
    status: 'Pending',
    age: 24,
  },
  {
    id: 17,
    username: 'gautam_p',
    image: 'https://www.shutterstock.com/image-vector/black-woman-smiling-portrait-vector-600nw-2281497689.jpg',
    email: 'gautam@gmail.com',
    password: 'gautam123',
    status: 'Active',
    age: 32,
  },
  {
    id: 18,
    username: 'ruchi_k',
    image: 'https://www.shutterstock.com/image-vector/black-woman-smiling-portrait-vector-600nw-2281497689.jpg',
    email: 'ruchi@example.com',
    password: 'ruchi789',
    status: 'Blocked',
    age: 29,
  },
  {
    id: 19,
    username: 'ayush_verma',
    image: 'https://www.shutterstock.com/image-vector/black-woman-smiling-portrait-vector-600nw-2281497689.jpg',
    email: 'ayushv@example.com',
    password: 'ayushpass',
    status: 'Active',
    age: 23,
  },
  {
    id: 20,
    username: 'sneha_kumar',
    image: 'https://www.shutterstock.com/image-vector/black-woman-smiling-portrait-vector-600nw-2281497689.jpg',
    email: 'sneha.kumar@gmail.com',
    password: 'sneha@123',
    status: 'Pending',
    age: 27,
  },
  {
    id: 21,
    username: 'gautam_p',
    image: 'https://www.shutterstock.com/image-vector/black-woman-smiling-portrait-vector-600nw-2281497689.jpg',
    email: 'gautam@gmail.com',
    password: 'gautam123',
    status: 'Active',
    age: 32,
  },
  {
    id: 22,
    username: 'ruchi_k',
    image: 'https://www.shutterstock.com/image-vector/black-woman-smiling-portrait-vector-600nw-2281497689.jpg',
    email: 'ruchi@example.com',
    password: 'ruchi789',
    status: 'Blocked',
    age: 29,
  },
  {
    id: 23,
    username: 'ayush_verma',
    image: 'https://www.shutterstock.com/image-vector/black-woman-smiling-portrait-vector-600nw-2281497689.jpg',
    email: 'ayushv@example.com',
    password: 'ayushpass',
    status: 'Active',
    age: 23,
  },
  {
    id: 24,
    username: 'sneha_kumar',
    image: 'https://www.shutterstock.com/image-vector/black-woman-smiling-portrait-vector-600nw-2281497689.jpg',
    email: 'sneha.kumar@gmail.com',
    password: 'sneha@123',
    status: 'Pending',
    age: 27,
  },
];
